import React from 'react';
import PropTypes from 'prop-types';

import { Nav } from './styles';

const TextNavbar = ({
  navbarBackgroundColor,
  navbarBorderColor,
  navbarColor,
  navbarHeight,
  navbarPad,
  navbarText,
  navbarTextSize
}) => (
  <Nav
    backcolor={navbarBackgroundColor}
    bordercolor={navbarBorderColor}
    color={navbarColor}
    height={navbarHeight}
    pad={navbarPad}
    textSize={navbarTextSize}
  >
    {navbarText}
  </Nav>
);

TextNavbar.defaultProps = {
  navbarBackgroundColor: '#CFCFCF',
  navbarBorderColor: 'transparent',
  navbarColor: '#2E2C2A',
  navbarHeight: '5%',
  navbarPad: '0.1rem',
  navbarText: 'This is your custom title',
  navbarTextSize: '15px'
};

TextNavbar.propTypes = {
  navbarBackgroundColor: PropTypes.string,
  navbarBorderColor: PropTypes.string,
  navbarColor: PropTypes.string,
  navbarHeight: PropTypes.string,
  navbarPad: PropTypes.string,
  navbarText: PropTypes.string,
  navbarTextSize: PropTypes.string
};

export default TextNavbar;
